"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CustomIconOrImage = _interopRequireDefault(require("../shared/CustomIconOrImage"));
var _services = require("../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StyledGridRow = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  flex: 1;
`;
const StyledGridColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto 0px;
  gap: 10px;
  & [class^='rc-slider-mark-text'] {
    white-space: nowrap;
  }
`;
const StyledSubTitle = (0, _styledComponents.default)(StyledGridColumn)`
  text-align: center;
  font-size: 95%;
`;
const BorderedContainer = _styledComponents.default.div`
  padding: 20px;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 15px;
`;
const Slider = _ref => {
  let {
    min,
    max,
    step,
    labels,
    value,
    icon,
    src,
    onChangeValue,
    defaultSelection,
    title,
    subtitle,
    idPrefix = '',
    showPriceOnToolTip,
    showSubtitleOnChange,
    sliderStyle,
    id
  } = _ref;
  const inputLabels = {};
  labels.forEach(element => {
    inputLabels[element.value] = element.label;
  });
  const [showSubtitle, setShowSubtitle] = (0, _react.useState)(true);
  const defaultValue = defaultSelection ? defaultSelection[0] : value;
  const [recommendedValue] = (0, _react.useState)(defaultValue);
  const sliderRef = (0, _react.useRef)(null);
  const observer = new MutationObserver(() => {
    if (showPriceOnToolTip) {
      const element = document.querySelector('.rc-slider-tooltip-inner');
      if (element && !element.classList.contains('shown')) {
        var _element$classList;
        element.innerHTML = _services.locale.formatPrice(element.innerHTML).toString();
        (_element$classList = element.classList) === null || _element$classList === void 0 ? void 0 : _element$classList.add('shown');
      }
      if (element && element.classList.contains('changed')) {
        element.innerHTML = _services.locale.formatPrice(element.innerHTML).toString();
        element.classList.remove('changed');
      }
    } else {
      const sliderTooltip = document.querySelector('.rc-slider-tooltip');
      if (sliderTooltip) {
        sliderTooltip.remove();
      }
    }
  });
  const checkRecommendedValue = () => {
    if (!showSubtitleOnChange) {
      setShowSubtitle(value === recommendedValue);
    }
  };
  (0, _react.useEffect)(() => {
    checkRecommendedValue();
  }, [value]);
  (0, _react.useEffect)(() => {
    if (sliderRef !== null && sliderRef !== void 0 && sliderRef.current) {
      observer.observe(sliderRef.current, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    return () => {
      observer.disconnect();
    };
  }, []);
  const onChangeSliderValue = value => {
    var _element$classList2;
    const element = document.querySelector('.rc-slider-tooltip-inner');
    if (element) (_element$classList2 = element.classList) === null || _element$classList2 === void 0 ? void 0 : _element$classList2.add('changed');
    onChangeValue(value);
  };
  const ContainerWrapper = sliderStyle.border ? BorderedContainer : _r10SourceLibrary.Container;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: sliderRef,
    id: id
  }, /*#__PURE__*/_react.default.createElement(StyledGridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(ContainerWrapper, {
    "data-test-id": "budget-question-subtitle",
    elevation: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    marginTop: 0
  }, /*#__PURE__*/_react.default.createElement(StyledGridColumn, {
    col: 12
  }, (src || icon) && /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    testId: "bugdet-slider-icon",
    name: icon,
    group: "midLight",
    size: 1,
    src: src
  }), title && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    dataAttributes: {
      'data-test-id': 'budget-question-title'
    },
    size: 2,
    weight: 3
  }, title)), subtitle && showSubtitle && /*#__PURE__*/_react.default.createElement(StyledSubTitle, {
    col: 12
  }, subtitle)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    marginTop: 5,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(StyledGridColumn, {
    col: 10
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.RangeSlider, {
    id: `${idPrefix}range-slider`,
    min: min,
    max: max,
    increment: step,
    value: value,
    onChange: onChangeSliderValue,
    showDots: false,
    rangeLabels: inputLabels,
    appearance: "secondary",
    srLabel: {
      mainLabel: title
    }
  })))))));
};
var _default = Slider;
exports.default = _default;